import React, { useEffect, useState } from 'react';
import { baseURLPublic } from '../../config/BaseUrl';

export default function EventRolloutGate({ eventId, pilot: Pilot, legacy: Legacy }) {
  const [result, setResult] = useState({});
  useEffect(() => {
    let active = true;
    if (!/^\d+$/.test(String(eventId || ''))) return undefined;
    baseURLPublic.get(`social-gallery-rollout/${eventId}`).then(({ data }) => {
      if (active) setResult({ eventId, enabled: data?.data?.enabled === true });
    }).catch(() => {
      // Unavailable/older rollout endpoint keeps the existing public experience.
      if (active) setResult({ eventId, enabled: false });
    });
    return () => { active = false; };
  }, [eventId]);
  if (!/^\d+$/.test(String(eventId || ''))) return <main role="alert">This gallery link is unavailable.</main>;
  if (result.eventId !== eventId) return <main role="status" style={{ padding: 40, textAlign: 'center' }}>Loading gallery…</main>;
  return result.enabled ? <Pilot /> : <Legacy />;
}
